import { getAuthKey, getServiceUrl } from '../CONFIG';

const loaderCounters = {};

function postDataWithNodeServiceApi(apiUrl, spParams, callBack, counterName, isLoadingDoneCallback, callBackOnError, isAsync = false) {
    updateCounters(counterName, isLoadingDoneCallback);
    
    serviceCall(apiUrl, spParams, callBack, counterName, isLoadingDoneCallback, callBackOnError, isAsync);
}

function postDataWithETenderNodeServiceApi(apiUrl, spParams, callBack, counterName, isLoadingDoneCallback, callBackOnError, isAsync = false) {
    updateCounters(counterName, isLoadingDoneCallback);

    serviceCall(apiUrl, spParams, callBack, counterName, isLoadingDoneCallback, callBackOnError, isAsync, 'etender');
}

function updateCounters(counterName, isLoadingDoneCallback) {
    if (counterName) {
        if (!loaderCounters[counterName]) {
            loaderCounters[counterName] = 1;
        }
        else {
            loaderCounters[counterName] += 1;
        }

        if (loaderCounters[counterName] === 1 && isLoadingDoneCallback) {
            isLoadingDoneCallback(false);
        }
    }
}

function serviceCall(apiUrl, spParams, callBack, counterName, isLoadingDoneCallback, callBackOnError, isAsync, serviceId) {
    callNodeServiceApi(apiUrl, spParams, isAsync, serviceId)
        .then(res => res.json()
            .then(resjson => {
                if (callBack) { callBack(resjson); }
                decrementCounter(counterName, isLoadingDoneCallback);
            })
            .catch(err => {
                if (callBackOnError) { callBackOnError(err); }
                decrementCounter(counterName, isLoadingDoneCallback);
            })
        )
        .catch(err => {
            if (callBackOnError) { callBackOnError(err) }
            decrementCounter(counterName, isLoadingDoneCallback);
        });
}

/*
//This method should be private and should not be exposed
*/
function decrementCounter(counterName, isLoadingDoneCallback) {
    if (counterName && loaderCounters[counterName]) {
        loaderCounters[counterName] -= 1;
        if (isLoadingDoneCallback && loaderCounters[counterName] === 0) {
            isLoadingDoneCallback(true);
        }
    }
    
}

function postDataWithNodeServiceApiPromise(apiUrl, spParams, isAsync = false) {
    return callNodeServiceApi(apiUrl, spParams, isAsync);
}


function postDataWithNodeServiceApiPromiseWithTVP(spName, spParams, tvpParamsArray, isAsync = false) {
    let serviceParams = {
        SpParams: spParams,
        TvpParams: tvpParamsArray
    };

    return callNodeServiceApi('executeSPWithTVP/' + spName, serviceParams, isAsync);
}

function postDataNodeServiceApiWithTVP(spName, spParams, tvpParamsArray, callBack, counterName, isLoadingDoneCallback, callBackOnError) {
    let serviceParams = {
        SpParams: spParams,
        TvpParams: tvpParamsArray
    };

    postDataWithNodeServiceApi('executeSPWithTVP/' + spName, serviceParams, callBack, counterName, isLoadingDoneCallback, callBackOnError);
}
//Added by vishnu jha
//date:30-03-2021
function postDataNodeServiceApiWithTVPeTender(spName, spParams, tvpParamsArray, callBack, counterName, isLoadingDoneCallback, callBackOnError) {
    let serviceParams = {
        SpParams: spParams,
        TvpParams: tvpParamsArray
    };

    postDataWithETenderNodeServiceApi('executeSPWithTVP/' + spName, serviceParams, callBack, counterName, isLoadingDoneCallback, callBackOnError);
}

/*
//This method should be private and should not be exposed
*/
function callNodeServiceApi(apiUrl, spParams, isAsync, serviceId) {
    var jsonParams = JSON.stringify(spParams)
    var urlApi = getServiceUrl(serviceId) + apiUrl;
    return fetch(urlApi,
        {
            method: 'POST',
            headers: {
                'Authorization': getAuthKey(),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: jsonParams,
            async: isAsync
        });
}

const updateDocument = (_url,body) => {
    fetch(_url  ,{
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body :JSON.stringify(body),
        async: true
      }).then((res)=>{
      });
}
 

module.exports.callApi = updateDocument;
module.exports.postDataWithNodeServiceApi = postDataWithNodeServiceApi;
module.exports.postDataWithETenderNodeServiceApi = postDataWithETenderNodeServiceApi;
module.exports.postDataWithNodeServiceApiPromise = postDataWithNodeServiceApiPromise;
module.exports.postDataNodeServiceApiWithTVP = postDataNodeServiceApiWithTVP;
module.exports.postDataWithNodeServiceApiPromiseWithTVP = postDataWithNodeServiceApiPromiseWithTVP;
module.exports.postDataNodeServiceApiWithTVPeTender = postDataNodeServiceApiWithTVPeTender;